import { render, staticRenderFns } from "./ReviewFooter.vue?vue&type=template&id=a15e5272&"
import script from "./ReviewFooter.vue?vue&type=script&lang=js&"
export * from "./ReviewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports